import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import gsap from "gsap"
import Observer from "gsap/Observer"
import KylePortraitHand from "../../src/assets/images/kyle_hand_portraitdarkgreyish1.png"
function SolarSystem(props) {


    const [spaceParticles, setSpaceParticles] = useState([])

    const animationRef = useRef(null)

    useEffect(() => {

        const orbitSizePositionMap = new Map([
            [0, { size: 100, position: "" }],
            [1, { size: 70, position: "" }],
            [2, { size: 50, position: "" }],
            [3, { size: 33, position: "" }],
        ])
        if (animationRef.current) {
            animationRef.current.kill()
        }
        let animationt1 = gsap.timeline()
        animationt1.set(".sun-center", {opacity: 0})
        animationt1.fromTo(".sun-center", {opacity: 0}, {opacity: 100, duration: 4, ease: "power3.in"}, 0)
        animationt1.fromTo(".sun-center", {
            width: "200vw", height: "200vw",
        }, {
            width: "100px", height: "100px", duration: 1.5,
        }, 0)
        animationt1.fromTo(
            ".orbit",
            {
                width: "0%",
                height: "0%",
                left: `50%`,
                top: `50%`,
                opacity: 0
            },
            {
                width: (index) => `${orbitSizePositionMap.get(index).size}%`,
                height: (index) => `${orbitSizePositionMap.get(index).size}%`,
                left: (index) => `${(100 - orbitSizePositionMap.get(index).size) / 2}%`,
                top: (index) => `${(100 - orbitSizePositionMap.get(index).size) / 2}%`,
                duration: 1.2,
                opacity: 1,
                stagger: 0.25
            }
            , 1)

        animationRef.current = animationt1
    }, [])

    useEffect(() => {
        gsap.registerPlugin(Observer)
        const numberParticles = 25
        let particlesArray = []
        
        if (spaceParticles.length === 0) {
            for (let i = 0; i < numberParticles; i++) {
                particlesArray.push(<div className="space-particle" key={i}></div>)  
            }
            setSpaceParticles(particlesArray)
        } else {
            let animationt2 = gsap.timeline()
            animationt2.set(".space-particle", {
                left: (()=> `${Math.floor(Math.random() * 300) - 50}%`),
                top: (() => `${Math.floor(Math.random() * 100)}%`)
                
            })
            animationt2.to(".space-particle", {
                left: (()=> `${Math.floor(Math.random() * 300) - 50}%`),
                top: (()=> `${Math.floor(Math.random() * 200) - 50}%`),
                duration: (() => Math.floor(300) + 1),
                ease: "sine.inout",
                yoyo: true,
                repeat: -1
            })

        }

        //set observer
        Observer.create({
            target: ".solar-system",
            onHover: dim,
            onHoverEnd: unDim
    })

        
    }, [spaceParticles])

    function dim() {
        gsap.to(".kyle-image-hand", {
            opacity: 0.1,
            duration: 1.2
        }) 
    }

    function unDim() {
        gsap.to(".kyle-image-hand", {
            opacity: 1,
            duration: 1.2,
        }) 
    }

    return (
        <>
        <img alt="Kyle Veloso with hand open" src={KylePortraitHand} className="kyle-image-hand"></img>
        <article className="solar-system space-particles-container">
           
            {spaceParticles}

            <div className="orbit orbit-i">
                <Link to="/about">
                    <div className="planet-art planet-i" onMouseEnter={props.handleHover}>
                        <div className="planet-art__clouds-container">
                            <div className="planet-i-cloud-1 planet-i-cloud"></div>
                            <div className="planet-i-cloud-2 planet-i-cloud"></div>
                            <div className="planet-i-cloud-3 planet-i-cloud"></div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className="orbit orbit-ii">
                <Link to="/projects">
                    <div className="planet-art planet-ii" onMouseEnter={props.handleHover}>
                        <div className="planet-art__clouds-container">
                            <div className="planet-ii-cloud-1 planet-ii-cloud"></div>
                            <div className="planet-ii-cloud-2 planet-ii-cloud"></div>
                            <div className="planet-ii-cloud-3 planet-ii-cloud"></div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className="orbit orbit-iii">
                <Link to="/skills">
                    <div className="planet-art planet-iii" onMouseEnter={props.handleHover}>
                        <div className="planet-art__clouds-container">
                            <div className="planet-iii-cloud-1 planet-iii-cloud"></div>
                            <div className="planet-iii-cloud-2 planet-iii-cloud"></div>
                            <div className="planet-iii-cloud-3 planet-iii-cloud"></div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className="orbit orbit-iv">
                <Link to="/leisure">
                    <div className="planet-art planet-iv" onMouseEnter={props.handleHover}>
                        <div className="planet-art__clouds-container">
                            <div className="planet-iv-cloud-1 planet-iv-cloud"></div>
                            <div className="planet-iv-cloud-2 planet-iv-cloud"></div>
                            <div className="planet-iv-cloud-3 planet-iv-cloud"></div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className="sun-art sun-center" onMouseEnter={props.handleHover}>
                <div className="sun-art__surface-container"></div>
            </div>
        </article>
        </>
    )
}

export { SolarSystem }